import React, { Component } from "react";

export default class JSFirstScript extends Component {

    render() {

        return(<div>Placeholder.</div>);

    }
    
}